import React, {useContext} from "react"

export const ObserverContext = React.createContext({
    classCode: undefined
})

export const useObserverContext = () => useContext(ObserverContext)
